export default "__VITE_ASSET__CAd5GF84__"